import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DATE_CALENDAR_FORMAT } from '@core/localization/localization.constants';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { B2bInvoiceFilterBody } from '../../../../shared/models/b2b-filter-invoice.model';
import { FormGroupWrapperModule } from '@ui/form/form-group-wrapper/form-group-wrapper.module';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CalendarRangeControlModule } from '@ui/form/calendar-range-control/calendar-range-control.module';
import { B2bInvoiceFilterFormField, B2bInvoiceFilterFormService } from './b2b-invoice-filter-form.service';
import { endOfDay, startOfDay } from 'date-fns';
import { convertDateTimeToDbFormat } from '@core/localization/local-date-adapter.helpers';
import {
    ListB2BInvoiceStatusResponse,
} from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-status-response';
import { ButtonModule } from '@ui/form/button/button.module';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * Filter invoices
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-invoice-filter',
    templateUrl: './b2b-invoice-filter.component.html',
    styleUrls: ['./b2b-invoice-filter.component.scss'],
    providers: [B2bInvoiceFilterFormService],
    imports: [FormGroupWrapperModule, NgSelectComponent, ReactiveFormsModule, CalendarRangeControlModule, ButtonModule, TranslatePipe],
})
export class B2bInvoiceFilterComponent {
    /**
     * B2b program Id
     */
    @Input() public prgId: number;
    /**
     * Server pending flag
     */
    @Input() public pending: boolean;
    /**
     * Statuses list
     */
    @Input() public statuses: ListB2BInvoiceStatusResponse[];
    /**
     * Submit form event
     *
     * @returns Form data
     */
    @Output() public submitForm: EventEmitter<B2bInvoiceFilterBody> = new EventEmitter<B2bInvoiceFilterBody>();

    readonly #b2bInvoiceFilterFormService: B2bInvoiceFilterFormService = inject(B2bInvoiceFilterFormService);

    public readonly calendarFormat: string = DATE_CALENDAR_FORMAT;
    public readonly b2bInvoiceFilterFormField: typeof B2bInvoiceFilterFormField = B2bInvoiceFilterFormField;
    public readonly form: FormGroup = this.#b2bInvoiceFilterFormService.createReactiveForm();

    public get date(): AbstractControl {
        return this.form.get(B2bInvoiceFilterFormField.Date);
    }

    constructor() {
        setTimeout(() => {
            this.handlerSubmit();
        });
    }

    public handlerSubmit(): void {
        const outputDate: Date[] = this.date.value;
        const stCode: number = Number(this.#b2bInvoiceFilterFormService.getValueByPath(B2bInvoiceFilterFormField.StCode));

        if (Array.isArray(outputDate)) {
            const startDate: Date = startOfDay(outputDate[0] as Date);
            const endDate: Date = endOfDay(outputDate[1] as Date);

            this.submitForm.emit({
                dateFrom: convertDateTimeToDbFormat(startDate),
                dateTo: convertDateTimeToDbFormat(endDate),
                prgId: this.prgId,
                ...(stCode > 0 ? { stCode } : null),
            });
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
